// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Curacao from '../_raw/flag/icon_flag_curacao.png';

export default () => <img src={Curacao} alt="Curacao" />;
